var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleWithCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.456 7.794a.469.469 0 010 .662l-4.375 4.375a.469.469 0 01-.662 0l-1.875-1.875a.469.469 0 01.662-.662l1.544 1.543 4.044-4.043a.469.469 0 01.662 0zM17.97 10A7.969 7.969 0 1110 2.031 7.978 7.978 0 0117.969 10zm-.938 0A7.031 7.031 0 1010 17.031 7.04 7.04 0 0017.031 10z",
    fill: "#1A1A1A"
  })));
}

export default SvgCircleWithCheck;